import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DragSymbol } from '../icons/icons';

export default function DragDropList({
  items,
  onChange,
  renderItem,
  ...otherProps
}) {
  const [dragIndex, setDragIndex] = useState(null);
  const [dropIndex, setDropIndex] = useState(null);
  // const [dropPosition, setDropPosition] = useState(null);

  const resetDragState = () => {
    setDragIndex(null);
    setDropIndex(null);
    // setDropPosition(null);
  };

  const handleDragStart = (e, index) => {
    setDragIndex(index);

    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('dragIndex', index.toString());
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();

    if (dragIndex === index) return;

    setDropIndex(index);
  };

  const handleDrop = (e, index) => {
    e.preventDefault();

    if (dragIndex === null || dragIndex === index) {
      resetDragState();
      return;
    }

    const updatedItems = [...items];

    // remove dragged item
    const [draggedItem] = updatedItems.splice(dragIndex, 1);

    // insert item
    updatedItems.splice(index, 0, draggedItem);

    // update positions
    const finalData = updatedItems.map((item, idx) => ({
      ...item,
      position: idx + 1,
    }));

    onChange(finalData);

    resetDragState();
  };

  const handleInputChange = (id, key, value) => {
    const updatedList = items.map((item) =>
      item.id === id
        ? {
            ...item,
            [key]: value,
          }
        : item
    );

    onChange?.(updatedList);
  };

  return items.map((item, index) => {
    const isDragging = dragIndex === index;

    const showDropIndicator = dropIndex === index && dragIndex !== index;

    return (
      <div
        key={item.id}
        draggable
        onDragStart={(e) => handleDragStart(e, index)}
        onDragOver={(e) => handleDragOver(e, index)}
        onDrop={(e) => handleDrop(e, index)}
        onDragEnd={resetDragState}
        className={`stop-row  ${isDragging ? 'dragging' : ''} ${
          dropIndex === index ? 'drag-over' : ''
        }`}
      >
        {showDropIndicator && (
          <div className="drop-indicator" {...otherProps} />
        )}

        <div className="stop-handle-col">
          <div
            className="grip"
            draggable
            onDragStart={(e) => handleDragStart(e, index)}
          >
            <DragSymbol />
          </div>
          <span className="timeline-dot" />
        </div>

        <div className="w-100">
          {renderItem?.({
            item,
            index,
            handleInputChange,
          })}
        </div>
      </div>
    );
  });
}

DragDropList.defaultProps = {
  items: [],
  onChange: () => {},
  renderItem: () => null,
};

DragDropList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      position: PropTypes.number,
    })
  ),
  onChange: PropTypes.func,
  renderItem: PropTypes.func,
};
